export default "__VITE_ASSET__CwbwaMrB__"